import { Link } from 'gatsby'
import styled from 'styled-components'
import vars from '../lib/styled'

export const Logo = styled(Link)`
  box-sizing: border-box;
  display: block;
  line-height: 0;
  margin-left: -1px;
  max-width: calc(100% - 103px);

  @media only screen and (min-width: ${vars.breakpoint.phone}) {
    max-width: 333px;
    min-height: 66px;
  }

  @media only screen and (min-width: ${vars.breakpoint.laptop}) {
    max-width: 357px;
    min-height: 71px;
  }

  @media only screen and (min-width: ${vars.breakpoint.desktop}) {
    max-width: 380px;
    min-height: 76px;
  }
`

export const LogoImage = styled.img`
  height: 100%;
  object-fit: contain;
  width: 100%;
`
